import { MainStoreUserEnvironmentState } from 'modules/main/store/ducks/userEnvironment';
import { hasUsedAts } from 'modules/orgDashboard/utils/ats';

export function promoteAts({
  userEnvironment,
}: {
  userEnvironment: MainStoreUserEnvironmentState;
}) {
  const { user } = userEnvironment;

  const isAdmin = (user?.orgs?.length || 0) > 0;

  const orgUsedAts = (user?.orgs.filter((org) => org.usedAts)?.length || 0) > 0;

  return isAdmin && !hasUsedAts() && !orgUsedAts;
}
